import {
	TASK_LIST_GENERIC_ACTIVITY_LIST_SORT,
	TASK_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE,
} from 'src/stores/taskList/localStorageKeys';
import { TSMap } from 'typescript-map';

import { DateRangeSelection } from 'src/models/common';
import { FilterBoxes, FilterUsers } from 'src/models/filter';
import {
	ActivityListTypeEnum,
	GenericActivityListPagination,
	GenericActivityListSort,
} from 'src/models/genericActivityList';
import { PreconfiguredTimeRanges } from 'src/models/miniCalendar';
import { SerializedQuery } from 'src/models/query';
import { TaskListItem } from 'src/models/taskList';

interface TaskListStateInterface {
	activeQueryIdentifierByListType: TSMap<ActivityListTypeEnum, string>;
	dateFilter: DateRangeSelection | string;
	dateTimeRangeFilter: PreconfiguredTimeRanges;
	filterBoxes: Array<FilterBoxes>;
	filterUsers: Array<FilterUsers>;
	filteredBoxIds: Array<string>;
	filteredUsers: Array<FilterUsers>;
	listViewModeLarge: boolean;
	pagination: TSMap<ActivityListTypeEnum, GenericActivityListPagination>;
	queryStoreSubscriptions: Array<SerializedQuery>;
	selectedSharedQueryId: string;
	sort: TSMap<ActivityListTypeEnum, GenericActivityListSort>;
	taskListAll: Array<TaskListItem>;
	taskListAllSliced: Map<number, Array<TaskListItem>>;
	taskListAllTotalCount: number;
	taskListMine: Array<TaskListItem>;
	taskListMineSliced: Map<number, Array<TaskListItem>>;
	taskListMineTotalCount: number;
	taskListOpen: Array<TaskListItem>;
	taskListOpenSliced: Map<number, Array<TaskListItem>>;
	taskListOpenTotalCount: number;
	today: string;
}

function state(): TaskListStateInterface {
	return {
		activeQueryIdentifierByListType: new TSMap<ActivityListTypeEnum, string>([
			[ActivityListTypeEnum.ALL, ''],
			[ActivityListTypeEnum.MINE, ''],
			[ActivityListTypeEnum.OPEN, ''],
		]),
		dateFilter: new Date().toISOString().split('T')[0],
		dateTimeRangeFilter: PreconfiguredTimeRanges.TODAY,
		filterBoxes: [],
		filterUsers: [],
		filteredBoxIds: [],
		filteredUsers: [],
		listViewModeLarge:
			localStorage.getItem(TASK_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) !== null
				? /true/i.test(
						localStorage.getItem(TASK_LIST_GENERIC_ACTIVITY_LIST_VIEW_MODE_LARGE) as 'false' | 'true'
					)
				: true,
		pagination: new TSMap<ActivityListTypeEnum, GenericActivityListPagination>([
			[ActivityListTypeEnum.ALL, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.MINE, { page: 1, rowsPerPage: 100 }],
			[ActivityListTypeEnum.OPEN, { page: 1, rowsPerPage: 100 }],
		]),
		queryStoreSubscriptions: [],
		selectedSharedQueryId: '',
		sort:
			localStorage.getItem(TASK_LIST_GENERIC_ACTIVITY_LIST_SORT) !== null
				? new TSMap<ActivityListTypeEnum, GenericActivityListSort>().fromJSON(
						JSON.parse(localStorage.getItem(TASK_LIST_GENERIC_ACTIVITY_LIST_SORT) as string)
					)
				: new TSMap<ActivityListTypeEnum, GenericActivityListSort>([
						[
							ActivityListTypeEnum.ALL,
							{
								direction: 'ASC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.ALL_MODULE_LISTS_AT_ONCE,
							{
								direction: 'ASC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.MINE,
							{
								direction: 'ASC',
								property: 'timestamp',
							},
						],
						[
							ActivityListTypeEnum.OPEN,
							{
								direction: 'ASC',
								property: 'timestamp',
							},
						],
					]),
		taskListAll: [],
		taskListAllSliced: new Map<number, Array<TaskListItem>>(),
		taskListAllTotalCount: 0,
		taskListMine: [],
		taskListMineSliced: new Map<number, Array<TaskListItem>>(),
		taskListMineTotalCount: 0,
		taskListOpen: [],
		taskListOpenSliced: new Map<number, Array<TaskListItem>>(),
		taskListOpenTotalCount: 0,
		today: new Date().toISOString().split('T')[0],
	};
}

export default state;
